const init = () => ({
  filter: {
    competitionId: undefined,
    round: undefined,
    team: undefined,
    laddertemplate: undefined,
  },
  currentTab: 'explore',
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    setCurrentTab(state, payload) {
      console.log('setCurrentTab', payload);
      state.currentTab = payload;
    },
    clear(state) {
      state = init();
    },
    setCompetitionId(state, payload) {
      state.filter.competitionId = payload;
    },
    setRound(state, payload) {
      state.filter.round = payload;
    },
    setTeam(state, payload) {
      state.filter.team = payload;
    },
    setLaddertemplate(state, payload) {
      state.filter.laddertemplate = payload;
    }
  },
  actions: {
  },
  getters: {
    getLaddertemplate(state) {
      return state.filter.laddertemplate;
    },
    currentTab(state) {
      return state.currentTab;
    },
    getCompetitionId(state) {
      return state.filter.competitionId;
    },
  },
};
